import * as Yup from 'yup';
import { CategoryTypeList } from '../../../../utils/enum';

export const typeSchema = {
  title: Yup.string()
    .min(2, '최소 2자리이상 입력해주세요.')
    .max(255, '최대 255자리입니다.')
    .required('필수 입력값입니다.'),
  file: Yup.mixed().required('이미지를 선택해주세요.'),
  notes: Yup.string().max(1000, '최대 1000자리입니다.').nullable(),
};

export const typeDefaultValue = {
  categoryId: '',
  title: '',
  file: null,
  categoryType: CategoryTypeList.REGULAR,
  notes: '',
};

export const sportingSchema = {
  title: Yup.string()
    .min(2, '최소 2자리이상 입력해주세요.')
    .max(255, '최대 255자리입니다.')
    .required('필수 입력값입니다.'),
  subCategoryType: Yup.string().required('필수 선택값입니다.'),
  notes: Yup.string().max(1000, '최대 1000자리입니다.').nullable(),
};

export const sportingDefaultValue = {
  title: '',
  subCategoryType: '',
  notes: '',
};

export const statusSchema = {
  title: Yup.string()
    .min(2, '최소 2자리이상 입력해주세요.')
    .max(255, '최대 255자리입니다.')
    .required('필수 입력값입니다.'),
  notes: Yup.string().max(1000, '최대 1000자리입니다.').nullable(),
};

export const statusDefaultValue = {
  title: '',
  inspectionResultTypeId: '',
  notes: '',
};

export const departmentSchema = {
  title: Yup.string()
    .min(2, '최소 2자리이상 입력해주세요.')
    .max(255, '최대 255자리입니다.')
    .required('필수 입력값입니다.'),
  description: Yup.string().max(1000, '최대 1000자리입니다.').nullable(),
};

export const departmentDefaultValue = {
  title: '',
  departmentId: '',
  description: '',
};
